// extracted by mini-css-extract-plugin
export default {"container":"CoreQuote-module__container-hd00B4","quote":"CoreQuote-module__quote-_W6sj9","footer":"CoreQuote-module__footer-f6aXOC"};